import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuotesService {

  constructor(private http: HttpClient) { }

  private baseUrl: string = environment.apiUrl;

  private static handleError(error: HttpErrorResponse) {
    console.log(error);

    // return an observable with a user friendly message
    return throwError('Error! something went wrong.');
  }

  addQuote(Payload: any) {
    return this.http.post<any>(`${this.baseUrl}/quote/add-quote`, Payload)
      .pipe(map(res => {
        return res;
      }));

  }

  addQuoteContent(Payload: any) {
    return this.http.post<any>(`${this.baseUrl}/quote/add-quote-content`, Payload)
      .pipe(map(res => {
        return res;
      }));

  }

  addQuoteContentWithProgress(Payload: any) {
    return this.http.post<any>(`${this.baseUrl}/quote/add-quote-content`, Payload, {reportProgress: true,observe: 'events'})
      .pipe(map(res => {
        return res;
      }));

  }

  getAllQuote(): Observable<any> {
    return this.http.get(`${this.baseUrl}/quote/get-quote`).pipe(
      map((res) => {
        return res;
      }),
      catchError(QuotesService.handleError));
  }

  getAllQuoteContent(): Observable<any> {
    return this.http.get(`${this.baseUrl}/quote/get-quote-content`).pipe(
      map((res) => {
        return res;
      }),
      catchError(QuotesService.handleError));
  }

  getQuoteContentById(id: any): Observable<any> {
    return this.http.get(`${this.baseUrl}/quote/get-quote-content/${id}`).pipe(
      map((res) => {
        return res;
      }),
      catchError(QuotesService.handleError));
  }

  deleteQuoteContent(id: any): Observable<any> {
    return this.http.get(`${this.baseUrl}/quote/delete-quote-content/${id}`).pipe(
      map((res) => {
        return res;
      }),
      catchError(QuotesService.handleError));
  }

  editQuoteContent(id: any, data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/quote/edit-quote-content/${id}`, data).pipe(
      map((res) => {
        return res;
      }),
      catchError(QuotesService.handleError));
  }

  editQuoteContentWithProgress(id: any, data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/quote/edit-quote-content/${id}`, data, {reportProgress: true,observe: 'events'}).pipe(
      map((res) => {
        return res;
      }),
      catchError(QuotesService.handleError));
  }

  getTodayQuote(): Observable<any> {
    return this.http.get(`${this.baseUrl}/quote/get-today-quote`).pipe(
      map((res) => {
        return res;
      }),
      catchError(QuotesService.handleError));
  }

}
